import { useState, useMemo } from 'react';
import { Suggest } from 'react-geosuggest';
import { defaultLatLong } from '~/Constants/Values.constants';

export type IGeoResult = {
  geometry: {
    location: {
      lat: Function;
      lng: Function;
    };
  };
};

export const useInputAddress = () => {
  const [suggestAddress, setSuggestAddress] = useState<Suggest>();
  const { city, zipCode, street, countryISOA2, latitude, longitude, countryName } = useMemo(() => {
    if (!suggestAddress) {
      return {};
    }
    const street = suggestAddress?.gmaps?.address_components?.find((s) => s.types.includes('route'))
      ?.long_name;
    const number = suggestAddress?.gmaps?.address_components?.find((s) =>
      s.types.includes('street_number'),
    )?.long_name;
    const countryName = suggestAddress?.gmaps?.address_components?.find((s) =>
      s.types.includes('country'),
    )?.long_name;
    const streetDetail = number ? `${street} ${number}` : street || '';
    return {
      city: suggestAddress?.gmaps?.address_components?.find((s) => s.types.includes('locality'))
        ?.long_name,
      zipCode: suggestAddress?.gmaps?.address_components?.find((s) =>
        s.types.includes('postal_code'),
      )?.long_name,
      street: streetDetail,
      countryISOA2: suggestAddress?.gmaps?.address_components?.find((s) =>
        s.types.includes('country'),
      )?.short_name,
      latitude: suggestAddress?.location?.lat,
      longitude: suggestAddress?.location?.lng,
      countryName,
    };
  }, [suggestAddress]);

  const onSuggestSelect = (suggest: Suggest) => {
    if (suggest) {
      setSuggestAddress(suggest);
    }
  };

  return {
    onSuggestSelect,
    city,
    zipCode,
    street,
    countryISOA2,
    latitude: latitude || defaultLatLong.lng,
    longitude: longitude || defaultLatLong.lng,
    countryName: countryName || '',
  };
};
